"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileGrid = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledTileGrid = styled_components_1.default.ul `
	display: grid;
	justify-content: ${({ customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.content) === null || _a === void 0 ? void 0 : _a.justify) !== null && _b !== void 0 ? _b : 'center'; }};
	grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};
	grid-gap: 16px;
	width: 100%;
	list-style-type: none;
	padding-left: 0;
	color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.gray2; }};
	border-color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.gray2; }};


	@media (max-width: 41em) {
		grid-template-columns: repeat(auto-fit, minmax(160px, max-content));
		grid-gap: 5px;
	}
`;
const defaultProps = {
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, max-content))'
};
const TileGrid = ({ gridTemplateColumns, children, ariaLabelledBy, customStyle }) => react_1.default.createElement(StyledTileGrid, { gridTemplateColumns: gridTemplateColumns, "aria-labelledby": ariaLabelledBy, customStyle: customStyle }, children);
exports.TileGrid = TileGrid;
exports.TileGrid.defaultProps = defaultProps;
